import React from 'react';
import { LOGO_ASSETS } from '../utils/assets';
import useInfiniteSlider from '../hooks/useInfiniteSlider';

const LogosSection: React.FC = () => {
  const { sliderProps } = useInfiniteSlider(true);

  const logos = [
    { src: LOGO_ASSETS.channels42, alt: '42 Channels Logo' },
    { src: LOGO_ASSETS.m8werk, alt: 'M8Werk Group Logo' },
    { src: LOGO_ASSETS.presseaugsburg, alt: 'PresseAugsburg Logo' },
    { src: LOGO_ASSETS.serviceunion, alt: 'ServiceUnion Logo' },
    { src: LOGO_ASSETS.ideenbutze, alt: 'Ideenbutze Logo' },
    { src: LOGO_ASSETS.allsafe, alt: 'allsafe Logo' },
    { src: LOGO_ASSETS.osnalive, alt: 'osna.live Logo' },
    { src: LOGO_ASSETS.lernkarten, alt: 'HFW Lernkarten Logo' },
    { src: LOGO_ASSETS.nextserve, alt: 'NextServe Logo' },
  ];

  return (
    <section>
      <div className="logos">
        <div {...sliderProps}>
          {logos.map((logo, index) => (
            <div key={index} className="logo-item">
              <img 
                src={logo.src} 
                alt={logo.alt}
                loading="lazy"
                className="company-logo"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LogosSection;
